import { graphql, useLazyLoadQuery } from "react-relay"
import { useWaitingRoomDrawerQuery as waitingRoomDrawerQueryOperation } from "@/modules/waiting-room/services/__generated__/useWaitingRoomDrawerQuery.graphql"

const waitingRoomDrawerQuery = graphql`
  query useWaitingRoomDrawerQuery($id: ID!) {
    waitingRoomAppointmentById(id: $id) {
      ...appointmentDrawer_waitingRoomAppointment
      ...waitingRoomPreview_waitingRoomAppointment
    }
  }
`

export function useWaitingRoomDrawerQuery(id: string) {
  const { waitingRoomAppointmentById: waitingRoomAppointment } = useLazyLoadQuery<waitingRoomDrawerQueryOperation>(
    waitingRoomDrawerQuery,
    { id },
    {
      fetchPolicy: "store-or-network",
    },
  )

  return waitingRoomAppointment
}
